/**
 * "Baixar" na linha do documento (E205.F4.T03): o original pela rota que confere a custódia, salvo
 * com o nome que o servidor saneou. A recusa diz a causa (`motivoDoArquivo`): a custódia que não
 * confere, o arquivo fora do caso, o recorte do acervo ou a falha da rede.
 */
import { useCallback, useState } from 'react';

import { motivoDoArquivo, type MotivoDoArquivo } from '@/components/MesaUnica/useDocumentoOriginal';
import { useApiClient } from '@/lib/api';
import { baixarArquivoOriginal } from '@/lib/case_source_documents';
import { salvarArquivoBaixado } from '@/lib/http_download';

export interface BaixarOriginal {
  baixando: boolean;
  motivo: MotivoDoArquivo | null;
  baixar: () => void;
}

export function useBaixarOriginal(caseId: string, docId: string, nome: string): BaixarOriginal {
  const client = useApiClient();
  const [baixando, setBaixando] = useState(false);
  const [motivo, setMotivo] = useState<MotivoDoArquivo | null>(null);
  const baixar = useCallback((): void => {
    setBaixando(true);
    setMotivo(null);
    void baixarArquivoOriginal(client, caseId, docId, nome)
      .then(salvarArquivoBaixado)
      .catch((err: unknown) => setMotivo(motivoDoArquivo(err)))
      .finally(() => setBaixando(false));
  }, [client, caseId, docId, nome]);
  return { baixando, motivo, baixar };
}
